import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    data: {
      seo: {
        title: 'Applied AI for Enterprise Transformation',
        description: 'Rêve builds secure applied AI systems, autonomous agentic workflows, intelligent onboarding orchestration, and zero-trust LLM architectures for enterprises.'
      }
    }
  },
  {
    path: 'services',
    loadComponent: () => import('./pages/capabilities/capabilities.component').then(m => m.CapabilitiesComponent),
    data: {
      seo: {
        title: 'Applied AI Services',
        description: 'Explore Rêve capabilities across intelligent onboarding, agentic automation, LLM orchestration, cognitive infrastructure, AI-led managed services, and zero-trust AI security.'
      }
    }
  },
  {
    path: 'services/:id',
    loadComponent: () => import('./pages/capabilities/service-details/service-details.component').then(m => m.ServiceDetailsComponent),
    data: {
      seo: {
        title: 'Applied AI Service',
        description: 'Detailed Rêve applied AI service capability for enterprise automation, infrastructure, security, and transformation programs.',
        type: 'service'
      }
    }
  },
  {
    path: 'about-us',
    loadComponent: () => import('./pages/intelligence/intelligence.component').then(m => m.IntelligenceComponent),
    data: {
      seo: {
        title: 'About Rêve Applied AI',
        description: 'Learn about Rêve, a high-end applied AI company with enterprise engineering experience across global cloud, AI, and automation programs.'
      }
    }
  },
  {
    path: 'plans',
    loadComponent: () => import('./pages/plans/plans.component').then(m => m.PlansComponent),
    data: {
      seo: {
        title: 'Plans',
        description: 'Review Rêve engagement plans for applied AI strategy, delivery, managed services, and enterprise transformation support.'
      }
    }
  },
  {
    path: 'partner-program',
    loadComponent: () => import('./pages/partner-program/partner-program.component').then(m => m.PartnerProgramComponent),
    data: {
      seo: {
        title: 'Partner Program',
        description: 'Partner with Rêve to deliver applied AI, cloud transformation, and enterprise automation services across global markets.'
      }
    }
  },
  {
    path: 'dynamics-365',
    loadComponent: () => import('./pages/dynamic-365/dynamic-365.component').then(m => m.Dynamic365Component),
    data: {
      seo: {
        title: 'Dynamics 365 Copilot Customization',
        description: 'Rêve integrates autonomous agents and augmented Copilot systems into Microsoft Dynamics 365 to improve service, ERP, and customer workflows.'
      }
    }
  },
  {
    path: 'blog',
    loadComponent: () => import('./pages/blogs/blogs.component').then(m => m.BlogsComponent),
    data: {
      seo: {
        title: 'Applied AI Blog',
        description: 'Read Rêve insights on agentic workflows, zero-trust AI security, enterprise LLM orchestration, cloud modernization, and managed services.'
      }
    }
  },
  {
    path: 'blog/:id',
    loadComponent: () => import('./pages/blogs/blog-details/blog-details.component').then(m => m.BlogDetailsComponent),
    data: {
      seo: {
        title: 'Applied AI Article',
        description: 'Rêve applied AI article covering enterprise automation, cloud transformation, AI orchestration, and secure delivery practices.',
        type: 'article'
      }
    }
  },
  {
    path: 'case-study',
    loadComponent: () => import('./pages/case-studies/case-studies.component').then(m => m.CaseStudiesComponent),
    data: {}
  },
  {
    path: 'case-study/:id',
    loadComponent: () => import('./pages/case-studies/case-study-details/case-study-details.component').then(m => m.CaseStudyDetailsComponent),
    data: {}
  },
  {
    path: 'careers',
    loadComponent: () => import('./pages/careers/careers.component').then(m => m.CareersComponent),
    data: {
      seo: {
        title: 'Careers',
        description: 'Explore careers at Rêve for applied AI engineers, cloud architects, automation specialists, and enterprise transformation teams.'
      }
    }
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent),
    data: {
      seo: {
        title: 'Frequently Asked Questions',
        description: 'Answers about Rêve agentic AI workflows, L0 and L1 support architectures, zero-trust LLM integration, and enterprise AI data safety.'
      }
    }
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    data: {
      seo: {
        title: 'Privacy Policy',
        description: 'Rêve privacy policy for website visitors, customers, partners, and enterprise AI service inquiries.'
      }
    }
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/legal/terms-service/terms-service.component').then(m => m.TermsServiceComponent),
    data: {
      seo: {
        title: 'Terms of Service',
        description: 'Rêve website terms of service for customers, partners, and visitors reviewing applied AI and cloud services.'
      }
    }
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    data: {
      seo: {
        title: 'Page Not Found',
        description: 'The requested Rêve page could not be found.',
        robots: 'noindex, follow'
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledNonBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
